import { QUOTES } from 'sites/routes'

export interface RedirectParams {
  period?: string
}
function redirectQuotes({ period = '' }: RedirectParams) {
  const url =
    QUOTES + '?' + [period && `period=${period}`, 'similar'].filter(Boolean).join('&')

  document.location.assign(url)
}

export default redirectQuotes
